import jwtDecode from '@nitra/jwt-decode'
import { getToken } from '@nitra/components/njs/token.js'

// const consola = createLogger('boot/userData')

export const user = jwtDecode(getToken())

// // ініціалізуємо Vuex та roles для Casl
// export default async () => {
//   consola.debug('Start UserData boot')

//   consola.debug('End userData boot')
// }
